"use strict";
var DESCRIPTORS = require("../internals/descriptors");
var fails = require("../internals/fails");
module.exports = DESCRIPTORS && fails(function() {
  return Object.defineProperty(function() {
  }, "prototype", {
    value: 42,
    writable: false
  }).prototype !== 42;
});
